import { ReviewsCarouselType } from '@utils/types';

const akhilaReview =
  'https://d222i9ppxs2fqe.cloudfront.net/d_Reviews_Akhila_White Pepper.png';
const mobileCarouselReview =
  'https://d222i9ppxs2fqe.cloudfront.net/mobileCarouselReview.png';
const desktopCarouselReview =
  'https://d222i9ppxs2fqe.cloudfront.net/desktopCarouselReview.png';

export const carouselContent: ReviewsCarouselType[] = [
  {
    id: 2,
    desktopIcon: akhilaReview,
    mobileIcon: akhilaReview,
    alt: 'akhilaReview',
    width: 200,
    height: 200,
    title: '',
    subtitle:
      'Amma may live far away, but now I can have home cooked meals every night with The Cumin Club.',
    ratings: 5,
  },
  {
    id: 1,
    desktopIcon: desktopCarouselReview,
    mobileIcon: mobileCarouselReview,
    alt: 'reviewPic',
    width: 200,
    height: 200,
    title: '',
    subtitle: 'Healthy, wholesome, and tasty food! A breeze to prepare.',
    ratings: 5,
  },
];
